var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEayIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2F5",
    d: "M9.997 4.719c-4.403 0-6.907 3.324-7.87 4.954-.224.378-.335.567-.323.861.011.295.142.48.402.85 1.136 1.61 3.98 5.001 7.791 5.001s6.656-3.39 7.791-5.001c.26-.37.391-.555.403-.85s-.1-.483-.323-.861c-.963-1.63-3.467-4.954-7.87-4.954"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A2540",
    d: "M10 5.094c-3.636 0-6.742 2.262-8 5.454 1.258 3.193 4.364 5.455 8 5.455s6.742-2.262 8-5.455c-1.258-3.192-4.364-5.454-8-5.454m0 9.09a3.64 3.64 0 0 1-3.636-3.636A3.64 3.64 0 0 1 10 6.912a3.64 3.64 0 0 1 3.636 3.636A3.64 3.64 0 0 1 10 14.185m0-5.818a2.18 2.18 0 0 0-2.182 2.182c0 1.208.975 2.182 2.182 2.182a2.18 2.18 0 0 0 2.182-2.182A2.18 2.18 0 0 0 10 8.366"
  })));
};
export default SvgEayIcon;